import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "SiteConfigViewContainer"
};
const _hoisted_2 = {
  class: "colFlex"
};
const _hoisted_3 = {
  class: "mr16"
};
const _hoisted_4 = {
  class: "light ft12"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_OssUploader = _resolveComponent("OssUploader");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString($data.siteName) + " - 站点配置", 1), _createVNode(_component_el_row, {
    style: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.configList, cfg => {
      return _openBlock(), _createBlock(_component_el_col, {
        key: `config_${cfg.configKey}`,
        span: 8,
        class: "colFlex pd12 mt12",
        style: {
          "background-color": "#F3F5F8"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "bothCenter mb6"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 18,
            class: "leftCenter"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(cfg.configName), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(cfg.configKey), 1)]), cfg.configValue?.startsWith('#') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(`background-color: ${cfg.configValue}`),
              class: "ml16 sqr18"
            }, null, 4)) : _createCommentVNode("", true), $options.isImg(cfg?.configValue) ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: "https://cdn.waityou.online/17c20788-9036-b8d1-fa60-e4b8acbe267c.svg",
              class: "sqr18 ml16 ptr",
              onClick: $event => $options.previewCfg(cfg)
            }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 6,
            class: "rightCenter"
          }, {
            default: _withCtx(() => [_createVNode(_component_OssUploader, {
              class: "mr16",
              "allowed-file-types": ['*'],
              onOnUploaded: u => $options.updateWithUrl(u, cfg)
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("img", {
                src: "https://cdn.waityou.online/3a2e928c-0d44-a789-97cf-8d6f49d8b35b.svg",
                class: "sqr18"
              }, null, -1)])),
              _: 2
            }, 1032, ["onOnUploaded"]), _createVNode(_component_el_button, {
              size: "small",
              onClick: $event => $options.updateConfig(cfg)
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("更新配置")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_el_input, {
          type: "textarea",
          modelValue: cfg.configValue,
          "onUpdate:modelValue": $event => cfg.configValue = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    title: "图片预览",
    width: "600px",
    "visible-control": $data.previewImgVisible,
    onClose: _cache[0] || (_cache[0] = $event => $data.previewImgVisible = false)
  }, {
    default: _withCtx(() => [$data.previewImgVisible ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: $data.previewImg,
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_6)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}